/**
 * The base URL for the release notes.
 * Resolves to an Azure Blob Storage URL.
 */
export const RELEASE_NOTES_BASE_URL = 'https://static.az.vestigas.com' as const;

/**
 * The base URL for assets of the release notes.
 * Resolves to an Azure Blob Storage URL.
 */
export const RELEASE_NOTES_ASSETS_BASE_URL =
  `${RELEASE_NOTES_BASE_URL}/release-notes` as const;

/**
 * The comparators supported for filtering the release notes by version number.
 */
export const VERSION_COMPARATORS = ['>', '>=', '=', '<', '<='] as const;

/**
 * The Vestigas applications supported for getting the release notes.
 */
export const RELEASE_NOTES_APPS = ['customer-portal', 'admin-portal'] as const;
